import { AddQueryString, ScenOptionUrl_spec, ScenarioUrl_spec, SetupAccountsUrl_get, SetupSavingRulesUrl_get, ftchPlus, getOptions, postOptions, scenOption, scenOptionClient } from "../../App/Account_urls";
import { chartSet } from "../../App/ChartViewSelector";
import { pdfChapter, pdfChart, pdfChart3, pdfChartCurrency, pdfChartGrid, pdfCover, pdfDisclaimer, pdfInputs, pdfRules, pdfScenInputs, pdfSummary, pdfTaxInfo } from "./pgChart3";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { myOwnFPColor } from "../../App/GridRenderers";
import { oas_columnDefs } from "../Oas/OasGrid";
import { gis_columnDefs } from "../Gis/GisGrid";
import { cpp_columnDefs } from "../Cpp/CppGrid";
// import { GoogleAnalyticsEvent } from "../../Components/ga4";
import { API_Client, APIs_GetScenarioInputs, APIs_pdflayout } from "../../App/api";

//pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.addVirtualFileSystem(pdfFonts);


export const marginX = 20
export const marginY = 20
const defaultMargin = [marginX, marginY]
export const pdfGridFontSize = 7
export const pdfGridFontScale = 0.55
export const pdfGridFontWidth = (pdfGridFontSize * pdfGridFontScale)
export const pdfTextFontSize = 9
export const HeaderHeight = 30
export const FooterHeight = 20



// const getLayout_ = async (clientJson, scen_uuid, onError) => {

//     var url = ScenarioUrl_spec(clientJson, scen_uuid, "pdflayout", "");
//     try {
//         let json = await ftchPlus(url, getOptions)
//         // console.log(json)
//         return json
//     } catch {

//     }
//     return { Pages: [] }
// };

const getLayout = async (clientJson, layoutId, onError) => {

    let q = AddQueryString("images=true", "pdflayout=" + layoutId)
    const url = ScenOptionUrl_spec(clientJson, APIs_pdflayout, null, q);

    try {
        let json = await ftchPlus(url, getOptions)
        // console.log(json)
        return json
    } catch {

    }
    return { Pages: [] }
};

const getCharts = async (clientJson, scen_uuid, chart, onError) => {
    // const response = await Axios.get(URL)
    //console.log(scen_uuid);
    //console.log(args);
    var url = ScenarioUrl_spec(clientJson, scen_uuid, "charts", "");
    let body = { "charts": [] }

    chart.map((c, i) => {
        let query = {
            "index": i,
            "query": ScenarioUrl_spec(clientJson, scen_uuid, c.chart, c.arg)
        }
        // console.log(query)
        body.charts.push(query)
        return ""
    })

    let req = postOptions
    req.body = JSON.stringify(body)
    //console.log(body)
    try {
        let json = await ftchPlus(url, req)
        //console.log(json)
        return json
    }
    catch {
    }
    return {}
}


const getGrids = async (clientJson, scen_uuid, grids, onError) => {
    // const response = await Axios.get(URL)
    //console.log(scen_uuid);
    //console.log(args);
    let resp = []
    for (let i = 0; i < grids.length; i++) {
        var url = ScenarioUrl_spec(clientJson, scen_uuid, grids[i].path, "");
        //console.log(grids[i].path)
        //console.log(url)
        let req = getOptions
        try {
            let json = await ftchPlus(url, req)
            // console.log(json)
            resp.push(json)
        }
        catch {
            resp.push([])
        }
    }
    // console.log(resp)
    return resp
}

export const getRules = async (clientJson, scen_uuid, rules, onError) => {
    // const response = await Axios.get(URL)
    //console.log(scen_uuid);
    //console.log(args);
    let resp = []
    for (let i = 0; i < rules.length; i++) {
        var url = SetupSavingRulesUrl_get(clientJson, scen_uuid, "");
        let req = getOptions
        try {
            let json = await ftchPlus(url, req)
            // console.log(json)
            resp.push(json)
        }
        catch {
            resp.push([])
        }
    }
    // console.log(resp)
    return resp
}

export const getInputs = async (clientJson, scen_uuid, inputs, onError) => {
    // const response = await Axios.get(URL)
    //console.log(scen_uuid);
    //console.log(args);

    let resp = []
    for (let i = 0; i < inputs.length; i++) {
        var url = SetupAccountsUrl_get(clientJson, scen_uuid, "");
        let req = getOptions
        try {
            let json = await ftchPlus(url, req)
            // console.log(json)
            resp.push(json)
        }
        catch {
            resp.push([])
        }
    }
    // console.log(resp)
    return resp
}

export const getScenarioInput = async (clientJson, scen_uuid, inputs, onError) => {
    let uuid = scen_uuid
    if (uuid === null) {
        uuid = clientJson.Scenario.uuid
    }
    let resp = []
    for (let i = 0; i < inputs.length; i++) {
        var url =
            API_Client +
            clientJson.uuid +
            APIs_GetScenarioInputs +
            scenOption(uuid);
        try {
            let json = await ftchPlus(url, getOptions)
            resp.push(json)
        }
        catch {
            resp.push([])
        }
    }
    return resp
}

const getInternals = async (clientJson, scen_uuid, internals, onError) => {

    let resp = []
    let json = {}
    var url =
        API_Client +
        clientJson.uuid +
        APIs_GetScenarioInputs +
        scenOptionClient(clientJson);
    try {
        json = await ftchPlus(url, getOptions)
        resp.push(json)
    }
    catch {
        resp.push([])
    }
    for (let i = 0; i < internals.length; i++) {
        resp.push(json)
    }
    return resp
}


// const generateWithDownload = async (clientJson, download) => {
//     let layout = await getLayout_(clientJson, clientJson.Scenario.uuid)
//     generate(clientJson, layout, download)

// }

const pageSize = (size) => {
    let s = 'legal'
    switch (size) {
        case 0:
            s = "letter"
            break;
        case 1:
            s = "legal"

            break;
        case 2:
            s = "tabloid"
            break;
        default:
            break;
    }
    return s
}


const generate = async (clientJson, layoutId, layout, avail, download, onError, preparedBy, executedDate) => {
    let gfs = pdfGridFontSize
    if (layout.GridFontSize >= 4 && layout.GridFontSize <= 15) {
        gfs = layout.GridFontSize
    }
    let tfs = pdfTextFontSize
    if (layout.TextFontSize >= 4 && layout.TextFontSize <= 15) {
        tfs = layout.TextFontSize
    }
    let docDefinition = {
        info: {
            title: "MyOwnFP Client: " + clientJson.name + (clientJson.spouseName ? " & " + clientJson.spouseName : "") + " Scenario: " + clientJson.Scenario.label,
            author: "MyOwnFP",
            subject: "Client: " + clientJson.name + (clientJson.spouseName ? " & " + clientJson.spouseName : "") + "\nScenario: " + clientJson.Scenario.label,
            keywords: "MyOwnFP " + clientJson.name + " " + (clientJson.spouseName ? clientJson.spouseName : "") + " " + clientJson.Scenario.label,
            creator: "MyOwnFP",
            producer: "MyOwnFP",

        },
        header: {
            margin: [marginX, 5],
            columns: [
                {
                    text: "  Client: " + clientJson.name + (clientJson.spouseName ? " & " + clientJson.spouseName : "") + ", Scenario: " + clientJson.Scenario.label,
                    alignment: "left",
                    fontSize: tfs,
                },
                {
                    text: "Prepared by: " + preparedBy,
                    alignment: "right",
                    fontSize: tfs,

                },
            ]
        },
        footer: {
            margin: [marginX, 5],
            text: "Powered by MyOwnFP",
            alignment: "right",
            fontSize: tfs - 1,
        },
        pageOrientation: "portrait",
        pageSize: pageSize(layout.PageSize),
        pageMargins: defaultMargin,
        content: [],
        images: {},
        styles: {
            gridValue: {
                alignment: "right",
                fontSize: gfs,
            },
            gridStart: {
                alignment: "right",
                bold: true,
                fontSize: gfs,
                background: myOwnFPColor,
            },
            gridMoney: {
                alignment: "right",
                fontSize: gfs,
            },
            gridPercent: {
                alignment: "right",
                fontSize: gfs,
            },
            header: {
                alignment: "right",
                fontSize: gfs,
                bold: true,
            },
            xheader: {
                alignment: "right",
                fontSize: gfs - 2,
                bold: false,
            },
            tableTitle: {
                fontSize: gfs + 2,
                bold: true,
            },
            ruleText: {
                fontSize: tfs,
                alignment: "left",
            },
            ruleHeading: {
                fontSize: tfs + 1,
                alignment: "left",
                bold: true,
                margin: [0, 10, 0, 0],
            },
            ruleHeading2: {
                fontSize: tfs + 2,
                alignment: "left",
                bold: true,
                margin: [0, 10, 0, 0],

            },
            ruleHeading3: {
                fontSize: tfs + 3,
                alignment: "left",
                bold: true,
                margin: [0, 10, 0, 0],
            },
            ChapterTitle: {
                fontSize: tfs + 10,
                alignment: "left",
                bold: true,
                margin: [0, 10, 0, 0],
            },
            important: {
                fontSize: tfs + 2,
                bold: true,
                margin: [0, 10, 0, 0],
            },

        }
    }

    // get all the charts in 1 step
    let charts = []
    let grids = []
    let rules = []
    let inputs = []
    let internals = []
    let scenInputs = []

    //console.log(layout)
    for (let i = 0; i < layout.Pages.length; i++) {
        let pg = layout.Pages[i]
        if (avail.ChartPageTypes.includes(pg.PageType)) {
            for (let cs = 0; cs < chartSet.length; cs++) {
                for (let c = 0; c < chartSet[cs].chart_rows.length; c++) {
                    for (let cr = 0; cr < chartSet[cs].chart_rows[c].length; cr++) {
                        if (pg.Id === chartSet[cs].chart_rows[c][cr].id) {
                            let respId = charts.length
                            charts.push(chartSet[cs].chart_rows[c][cr])
                            layout.Pages[i].ResponseId = respId
                        }
                    }
                }
            }
        } else if (pg.PageType === "Grid") {
            let respId = grids.length
            //console.log(pg.Id)
            //console.log(avail.Apis[pg.Id])
            grids.push({ path: avail.Apis[pg.Id] })
            layout.Pages[i].ResponseId = respId
        } else if (pg.PageType === "Text") {
            if (pg.Id === "Rules") {
                let respId = rules.length
                rules.push({ path: pg.Id })
                layout.Pages[i].ResponseId = respId
            } else if (pg.Id === "Inputs") {
                let respId = inputs.length
                inputs.push({ path: pg.Id })
                layout.Pages[i].ResponseId = respId
            } else if (pg.Id === "Internal") {
                let respId = internals.length
                internals.push({ path: pg.Id })
                layout.Pages[i].ResponseId = respId
            } else if (pg.Id === "ScenarioInputs" ||
                pg.Id === "TaxInformation") {
                if (scenInputs.length == 0) {
                    // only get this
                    let respId = scenInputs.length
                    scenInputs.push({ path: pg.Id })
                    layout.Pages[i].ResponseId = respId
                } else {
                    layout.Pages[i].ResponseId = 0
                }
            }
            else if ((pg.Id === "Disclaimer") ||
                (pg.Id === "Summary") ||
                (pg.Id === "Cover") ||
                (pg.Id === "Chapter")) {
                let respId = internals.length
                internals.push({ path: pg.Id })
                layout.Pages[i].ResponseId = respId
            }
        }

    }
    //console.log(layout)
    // console.log(charts)
    // console.log(grids)
    // the layout stored could be old, we just want to get it with the images
    //console.log(layoutId)
    let imgLayout = await getLayout(clientJson, layoutId)
    let [persona, tag] = layoutId.split(":")
    //console.log(imgLayout)
    imgLayout = imgLayout.Layouts[persona][tag]
    console.log(imgLayout)

    let chartResponse = await getCharts(clientJson, clientJson.Scenario.uuid, charts)
    // console.log(chartResponse)

    let gridResponse = await getGrids(clientJson, clientJson.Scenario.uuid, grids)
    // console.log(gridResponse)

    let ruleResponse = await getRules(clientJson, clientJson.Scenario.uuid, rules)
    // console.log(ruleResponse)

    let inputResponse = await getInputs(clientJson, clientJson.Scenario.uuid, inputs)
    // console.log(inputResponse)

    let scenInputResponse = await getScenarioInput(clientJson, clientJson.Scenario.uuid, scenInputs)
    // console.log(scenInputResponse)

    let internalResponse = await getInternals(clientJson, clientJson.Scenario.uuid, internals)
    // console.log(internalResponse)

    for (let i = 0; i < layout.Pages.length; i++) {
        let pg = layout.Pages[i]
        if (pg.ResponseId === undefined || pg.ResponseId === null) {
            continue
        }
        let content = []
        let images = {}
        if (pg.PageType === "Chart3") {
            content = await pdfChart3(clientJson, pg, chartResponse[pg.ResponseId], avail, layout.PageSize)
        } else if (pg.PageType === "ChartCurrency") {
            content = await pdfChartCurrency(clientJson, pg, chartResponse[pg.ResponseId], avail, layout.PageSize)
        } else if (pg.PageType === "Chart") {
            content = await pdfChart(clientJson, pg, chartResponse[pg.ResponseId], avail, layout.PageSize)
        } else if (pg.PageType === "ChartGrid") {
            content = await pdfChartGrid(clientJson, pg, chartResponse[pg.ResponseId], avail, null, layout.PageSize, layout.GridFontSize)
        } else if (pg.PageType === "Grid") {
            // some grids we have fixed layouts here in the UI
            let headers = null
            //console.log(pg)
            if (pg.Id === "Grid_CPP") {
                headers = cpp_columnDefs
            } else if (pg.Id === "Grid_OAS") {
                headers = oas_columnDefs
            } else if (pg.Id === "Grid_GIS") {
                headers = gis_columnDefs
            }
            content = await pdfChartGrid(clientJson, pg, gridResponse[pg.ResponseId], avail, headers, layout.PageSize, layout.GridFontSize)
        } else if (pg.PageType === "Text") {
            if (pg.Id === "Rules") {
                content = await pdfRules(clientJson, pg, ruleResponse[pg.ResponseId], layout.PageSize)
            } else if (pg.Id === "Inputs") {
                content = await pdfInputs(clientJson, pg, inputResponse[pg.ResponseId], layout.PageSize)
            } else if (pg.Id === "ScenarioInputs") {
                content = await pdfScenInputs(clientJson, pg, scenInputResponse[pg.ResponseId], layout.PageSize)
            } else if (pg.Id === "TaxInformation") {
                content = await pdfTaxInfo(clientJson, pg, scenInputResponse[pg.ResponseId], layout.PageSize)
            } else if (pg.Id === "Cover") {
                [content, images] = await pdfCover(clientJson, pg, internalResponse[pg.ResponseId], imgLayout, layout.PageSize, preparedBy, executedDate)
            } else if (pg.Id === "Chapter") {
                content = await pdfChapter(clientJson, pg, internalResponse[pg.ResponseId], imgLayout, layout.PageSize)
            } else if (pg.Id === "Summary") {
                content = await pdfSummary(clientJson, pg, internalResponse[pg.ResponseId], layout.PageSize)
            } else if (pg.Id === "Disclaimer") {
                content = await pdfDisclaimer(clientJson, pg, internalResponse[pg.ResponseId], layout.PageSize)
            } else {
                console.log(pg.Id + " ** Text page ID not found **")
            }
        }
        if (content.length > 0) {
            //console.log(content)
            docDefinition.content.push(...content)
        }
        if (Object.keys(images).length > 0) {
            //console.log(images)
            // this is an object not an array like content
            docDefinition.images = { ...docDefinition.images, ...images }
            // const newimages = [...docDefinition.images, ...images]
            // docDefinition.images = [...newimages]
        }
        //console.log(docDefinition)


    }
    if (docDefinition.content.length > 0) {
        try {
            delete (docDefinition.content[0].pageBreak)
        } catch {
        }
    }
    console.log(docDefinition)

    try {
        if (download) {
            //as download
            pdfMake.createPdf(docDefinition).download(docDefinition.info.title)
        } else {
            //as blob in new tab
            let win = window.open('', '_blank');
            if (!win) {
                console.log("Popup blocked by browser")
                throw new Error("MyOwnFP: Popup blocked by browser, please enable popups or use the download toggle")
            }
            pdfMake.createPdf(docDefinition).open(win)
            //as url in new tab(not working really, gets something back, doesn't open in new tab
            // const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            // let url = ""
            // pdfDocGenerator.getDataUrl((u) => url = u);
            // await new Promise(r => setTimeout(r, 1000));
            // //    console.log(url)
            // // maybe?
            // window.open(url, '_blank')

            // // maybe ??
            // let win2 = window.open('', '_blank');
            // win2.document.write(
            //     "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            //     encodeURI(url) + "'></iframe>"
            // )
        }
    } catch (error) {
        console.log(error);
        onError(error)
    }


    // GoogleAnalyticsEvent("pdf", "scenario", "", { action: "view" })

    // console.log("created pdf")



}




export const pdfGenerateStart = async (clientJson, layoutId, layout, avail, download, onError, preparedBy, executedDate) => {

    await generate(clientJson, layoutId, layout, avail, download, onError, preparedBy, executedDate)
}
